@if (loadPage) {
	<main class="claim-structure form-fields-sub-module">
		<div class="flex flex-row justify-between items-center mb-[50px] pr-[20px]">
			<div class="flex">
				@if (hasHistory || steps.length > 1 || currentLegalRequest?.phaseId > 1) {
					<div
						class="flex flex-row justify-between pt-[15px] pl-[20px] pr-[20px] pb-[15px] rounded-lg shadow-inner relative"
					>
						<div class="flex text-sm text-gray-700">
							{{ claimLabelsDict['other-phases'] }}
						</div>
						<div class="flex">
							<lbca-input-boolean
								(changeValue)="filterPhases($event)"
								[value]="getFieldv['oldPhases'].value"
							></lbca-input-boolean>
						</div>
					</div>
				}
			</div>
			@if (hasCapability) {
				<div class="flex">
					<button
						type="button"
						class="btn-primary btn-type-1"
						[disabled]="disabled"
						(click)="openModalPhase()"
					>
						{{ claimLabelsDict['new-phase'] }}
					</button>
				</div>
			}
		</div>
		@if (steps.length > 0) {
			@for (item of stepsRender; track item; let index = $index) {
				<ng-container>
					<div
						class="flex flex-row flex-wrap w-full pt-[20px] pl-[20px] pr-[20px] mb-[40px] rounded-lg shadow-inner relative theme-light-white"
						[class.transitionEntrada]="transition === 'entrada' && index > 0"
						[class.motion-unfill-right]="transition === 'saida' && index > 0"
						[style.animation-delay.ms]="index * 60"
					>
						<div class="text-base text-gray-600 pl-[10px] pr-[10px] bg-gray-50 absolute -top-[10px]">
							{{ item.label }}
						</div>
						<div class="flex flex-row justify-between items-center mb-[40px] mt-[20px] w-full">
							<div class="flex flex-row justify-between flex-wrap items-center w-full">
								<div class="justify-start flex flex-col mt-[20px] mb-[20px]">
									<lbca-input-text
										[labeled]="false"
										[componetHelperIconLeftStyle]="'quantidade-light-white'"
										[copyContent]="false"
										[label]="claimLabelsDict['quantity']"
										[value]="item.legalRequestCount"
									></lbca-input-text>
								</div>
								<div class="justify-start flex flex-col mt-[20px] mb-[20px]">
									<lbca-input-text
										[maskInput]="'CURRENCY_BR'"
										[labeled]="false"
										[componetHelperIconLeftStyle]="'total-inicial-light-white'"
										[copyContent]="false"
										[label]="claimLabelsDict['total-initial']"
										[value]="item.initCalculateValue"
									></lbca-input-text>
								</div>
								<div class="justify-start flex flex-col mt-[20px] mb-[20px]">
									<lbca-input-text
										[maskInput]="'CURRENCY_BR'"
										[componetHelperIconLeftStyle]="'total-atualizado-light-white'"
										[labeled]="false"
										[copyContent]="false"
										[label]="claimLabelsDict['total-updated']"
										[value]="item.updateCalculateValue"
									></lbca-input-text>
								</div>
								<div class="justify-start flex flex-col mt-[20px] mb-[20px]">
									<lbca-input-text
										[maskInput]="'CURRENCY_BR'"
										[componetHelperIconLeftStyle]="'risco-light-white'"
										[labeled]="false"
										[copyContent]="false"
										[label]="claimLabelsDict['total-risk-involved']"
										[value]="item.totalriskCalculate"
									></lbca-input-text>
								</div>
							</div>
							@if (hasCapability) {
								<div class="flex min-w-[130px] justify-center h-full mt-[40px]">
									<button
										type="button"
										class="btn-primary btn-type-1"
										[disabled]="disabled"
										(click)="openRegisterModal($event, item)"
									>
										{{ claimLabelsDict['register-claim'] }}
									</button>
								</div>
							}
						</div>
						<div [ngClass]="{ open: item.expandDetails }" class="claim-details" #detailsView>
							@if (
								tableDataClaim &&
								item.phaseId &&
								tableDataClaim[item.phaseId] &&
								tableDataClaim[item.phaseId].body &&
								tableDataClaim[item.phaseId].body.length === 0 &&
								tableDataClaim[item.phaseId].loaded
							) {
								<div
									class="w-full h-full relative flex justify-center items-center flex-col pb-[56px] transition duration-600 ease-in-out show"
								>
									<lbca-body-feedback feedbackIcon="noLegalrequests" type="claim">
										<ng-container claimMessagePrimary>
											{{ claimLabelsDict['no-legalrequests-registered'] }}
										</ng-container>
									</lbca-body-feedback>
								</div>
							}
							@if (
								item.phaseId &&
								tableDataClaim[item.phaseId] &&
								tableDataClaim[item.phaseId].body &&
								tableDataClaim[item.phaseId].body.length > 0
							) {
								<lbca-table-secondary
									[table]="tableDataClaim[item.phaseId]"
									[cardData]="cardInfo"
									[removeLine]="lineremove"
									[rightDeslocation]="line"
									[saveOnChange]="true"
									[disabled]="disabled"
									[paginationType]="item.motion"
									[formType]="'form-primary'"
								></lbca-table-secondary>
							}
						</div>
						<footer
							class="toggle-details text-sm text-gray-600 pl-[10px] pr-[10px] bg-gray-50 absolute right-60 bottom--7 cursor-pointer"
							(click)="openPhaseDetails(detailsView, toogleClose, item)"
						>
							<span #toogleClose>
								{{ item.expandDetails ? claimLabelsDict['close'] : claimLabelsDict['open'] }}
							</span>
						</footer>
					</div>
				</ng-container>
			}
		}
	</main>
}

<ng-template #actionsEditRender let-pedido>
	<div class="w-full flex items-center flex-row overflow-hidden justify-center">
		<label class="item-action-render" (click)="editItem($event, pedido)">
			<lbca-icon name="lucide:pencil" class="icon-box"></lbca-icon>
		</label>
	</div>
</ng-template>

<ng-template #actionsExcluirRender let-pedido>
	<div class="w-full flex items-center flex-row overflow-hidden justify-center">
		@if (isRemovable) {
			<label class="item-action-render" (click)="deleteItem($event, pedido)">
				@if (!pedido.remove) {
					<lbca-icon name="lucide:trash-2" class="icon-box"></lbca-icon>
				}
				@if (pedido.remove) {
					<lbca-icon name="lucide:circle-x" class="icon-box"></lbca-icon>
				}
			</label>
		}
	</div>
</ng-template>

<ng-template #ModalTemplate>
	<lbca-claim-phase
		[taskId]="taskId"
		[userId]="userId"
		[processId]="processId"
		[field]="field"
		[currentLegalRequest]="currentLegalRequest"
		[removeSteps]="removeSteps"
		[cardData]="cardInfo"
		(realoadDataOutput)="loadData()"
		(closeModalOutput)="closeModal()"
	/>
</ng-template>

<ng-template #ModalRegisterTemplate>
	<lbca-claim-new-legal-request
		[taskId]="taskId"
		[userId]="userId"
		[processId]="processId"
		[disabled]="disabled"
		[registerPhase]="registerPhase"
		[steps]="steps"
		[field]="field"
		[valoresRestore]="valoresRestore"
		[cardData]="cardInfo"
		[currentLegalRequest]="currentLegalRequest"
		(realoadDataOutput)="loadData()"
		(closeModalOutput)="closeModal()"
	/>
</ng-template>

<ng-template #ModalEdit>
	<lbca-claim-edit-legal-request
		[taskId]="taskId"
		[pedidoEdit]="pedidoEdit"
		[editPhase]="editPhase"
		[disabled]="disabled"
		[cardData]="cardInfo"
		[currentLegalRequest]="currentLegalRequest"
		(realoadDataOutput)="loadData()"
		(closeModalOutput)="closeModal()"
	/>
</ng-template>

<ng-template #templateMessage>
	<div class="text-base text-font flex items-center justify-center show">
		{{ feedtext }}
		<div [class]="emojis"></div>
	</div>
</ng-template>
